import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash.get';
import Banner from './Banner';
import { useAppContext } from '../../common/contexts/AppContext';
import { useBannerContext } from '../../common/contexts/BannerContext';
import { DICTIONARY_KEYS, localize } from '../../common/localization';

const getBannerMessage = hasInterventionInstruction =>
    hasInterventionInstruction ? (
        <div>
            <div className='dashboard-title'>Intervention</div>
            <div className='dashboard-text'>
                The following measures are required for progress monitoring to update the next set
                of lessons in mCLASS Intervention.
            </div>
        </div>
    ) : (
        <div>
            <div className='dashboard-title'>{localize(DICTIONARY_KEYS.RECOMMENDED_MEASURES)}</div>
            <div className='dashboard-text'>{localize(DICTIONARY_KEYS.RECOMMENDED_DESCRIPTION)}</div>
        </div>
    );

const PMBanner = ({ hasInterventionInstruction, studentUid }) => {
    const bannerContext = useBannerContext();
    const { classId } = useAppContext();
    const {
        actions: { hidePMRecommendationBanner },
    } = bannerContext;
    const isPMRecommendationBannerVisible = get(
        bannerContext[classId],
        `${studentUid}.isPMRecommendationBannerVisible`,
        true,
    );
    const dismissHandler = () => hidePMRecommendationBanner({ classId, studentUid });

    return isPMRecommendationBannerVisible ? (
        <Banner
            isInformation
            isDismissible
            dismissHandler={dismissHandler}
            className='dashboard-section dashboard-pm-section'
        >
            {getBannerMessage(hasInterventionInstruction)}
        </Banner>
    ) : null;
};

PMBanner.propTypes = {
    hasInterventionInstruction: PropTypes.bool,
    studentUid: PropTypes.string.isRequired,
};

PMBanner.defaultProps = {
    hasInterventionInstruction: false,
};

export default PMBanner;
